var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikes100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9531 119.469V120.891H34.5625V122.297H21.6562V120.891H27.2344V119.469H28.9531ZM22.2656 119C24.8125 118.844 26.5 117.984 26.8516 116.984H22.8438V115.656H33.3906V116.984H29.3438C29.6797 117.992 31.3516 118.844 33.9375 119L33.3906 120.297C30.7734 120.094 28.8438 119.211 28.1094 117.867C27.3672 119.203 25.4375 120.094 22.8281 120.297L22.2656 119ZM22.8438 125.188V123.875H27.2188V122.734H28.9688V123.875H33.3438V125.188H22.8438ZM23.7812 127.562C23.7734 126.352 25.3281 125.703 28.0781 125.703C30.8125 125.703 32.4062 126.352 32.4062 127.562C32.4062 128.797 30.8125 129.445 28.0781 129.438C25.3281 129.445 23.7734 128.797 23.7812 127.562ZM25.5625 127.562C25.5547 128.039 26.4453 128.281 28.0781 128.281C29.7422 128.281 30.5938 128.039 30.6094 127.562C30.5938 127.078 29.7422 126.875 28.0781 126.875C26.4453 126.875 25.5547 127.078 25.5625 127.562ZM39.2969 116.297C41.4219 116.297 42.9531 118.234 42.9688 121.281C42.9531 124.352 41.4219 126.281 39.2969 126.281C37.1484 126.281 35.6172 124.352 35.625 121.281C35.6172 118.234 37.1484 116.297 39.2969 116.297ZM37.2969 121.281C37.2891 123.453 38.1094 124.711 39.2969 124.719C40.4922 124.711 41.2891 123.453 41.2969 121.281C41.2891 119.125 40.4922 117.859 39.2969 117.859C38.1094 117.859 37.2891 119.125 37.2969 121.281ZM44.8281 129.391V115.266H46.5625V120.688H48.7344V122.156H46.5625V129.391H44.8281ZM60.3906 115.266V120.891H62.5625V122.328H60.3906V129.391H58.6719V115.266H60.3906ZM49.25 118.828V117.438H52.5938V115.469H54.3281V117.438H57.5781V118.828H49.25ZM49.9062 123.078C49.8906 121.125 51.4062 119.742 53.4688 119.75C55.5 119.742 57.0078 121.125 57.0156 123.078C57.0078 125.023 55.5 126.391 53.4688 126.391C51.4062 126.391 49.8906 125.023 49.9062 123.078ZM51.5625 123.078C51.5547 124.227 52.3594 124.961 53.4688 124.953C54.5547 124.961 55.3438 124.227 55.3594 123.078C55.3438 121.93 54.5547 121.172 53.4688 121.172C52.3594 121.172 51.5547 121.93 51.5625 123.078ZM70.4062 116.453V117.578H73.25V115.281H74.9844V125.562H73.25V122H70.4062V123.219H63.7656V116.453H70.4062ZM65.5 121.859H68.6875V117.828H65.5V121.859ZM65.6719 129.109V124.609H67.4375V127.703H75.2969V129.109H65.6719ZM70.4062 120.609H73.25V119H70.4062V120.609ZM87.2031 115.406C90.4219 115.414 92.2891 116.273 92.2969 117.828C92.2891 119.406 90.4219 120.258 87.2031 120.266C83.9922 120.258 82.1094 119.406 82.1094 117.828C82.1094 116.273 83.9922 115.414 87.2031 115.406ZM80.7812 122.359V121H93.6562V122.359H88.0625V123.438H92.0469V126.891H84.0156V127.938H92.4375V129.266H82.3125V125.656H90.3438V124.719H82.2969V123.438H86.3281V122.359H80.7812ZM83.9375 117.828C83.9297 118.609 85.0547 118.969 87.2031 118.984C89.3828 118.969 90.5 118.609 90.5 117.828C90.5 117.102 89.3828 116.711 87.2031 116.703C85.0547 116.711 83.9297 117.102 83.9375 117.828ZM106.375 115.266V129.406H104.656V115.266H106.375ZM95.375 117.906V116.5H102.031V121.797H97.1719V124.641C99.3984 124.625 101.312 124.508 103.516 124.141L103.672 125.562C101.273 125.977 99.1641 126.07 96.625 126.062H95.3906V120.422H100.266V117.906H95.375ZM119.875 119.266V120.641H110.094V115.781H111.812V119.266H119.875ZM108.422 123.656V122.281H121.328V123.656H108.422ZM109.969 129.062V124.906H111.703V127.656H119.969V129.062H109.969Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.022 48.9995C119.022 75.5248 97.5277 97.0195 71.0024 97.0195C44.4771 97.0195 22.9824 75.5248 22.9824 48.9995C22.9824 22.4742 44.4771 0.979492 71.0024 0.979492C97.5277 0.979492 119.022 22.4742 119.022 48.9995Z",
    fill: "url(#paint0_linear_1275_5288)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9962 81.9626C70.3724 81.9626 69.777 81.7074 69.3233 81.2821L53.6432 65.602C48.3976 60.3564 48.3976 51.85 53.6432 46.6044C56.1668 44.0808 59.541 42.6631 63.142 42.6631C66.0058 42.6631 68.6995 43.5421 70.9679 45.1866C76.2135 41.4155 83.5857 41.8975 88.2925 46.6044C90.8161 49.1279 92.2338 52.5021 92.2338 56.1032C92.2338 59.7042 90.8445 63.0784 88.2925 65.602L72.6124 81.2821C72.2155 81.7074 71.62 81.9626 70.9962 81.9626Z",
    fill: "#FFC25D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.0018,
    cy: 48.9999,
    r: 42.4906,
    stroke: "#FFC25D",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1275_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0432 16.8655L67.6523 19.4927C67.6008 19.5957 67.5235 19.6473 67.3947 19.673L64.4584 20.1882C63.6599 20.3169 62.9903 20.9094 62.7327 21.6821C62.4751 22.4548 62.6812 23.3048 63.2478 23.8972L65.3084 26.035C65.3857 26.1123 65.4114 26.2153 65.4114 26.3184L64.9993 29.2547C64.8705 30.0531 65.2311 30.8774 65.8751 31.3667C66.5447 31.8561 67.4205 31.9334 68.1417 31.5728L70.8204 30.2592C70.9234 30.2077 71.0265 30.2077 71.1295 30.2592L73.8082 31.5728C74.5552 31.9334 75.4052 31.8561 76.0749 31.3667C76.7446 30.8774 77.0794 30.0789 76.9506 29.2547L76.5385 26.3184C76.5127 26.2153 76.5643 26.1123 76.6415 26.035L78.7021 23.8972C79.2687 23.3048 79.4748 22.4548 79.2172 21.6821C78.9597 20.9094 78.29 20.3169 77.4915 20.1882L74.5552 19.673C74.4522 19.6473 74.3491 19.5957 74.2976 19.4927L72.9067 16.8655C72.5204 16.1443 71.7734 15.6807 70.9492 15.6807C70.1765 15.6807 69.4295 16.1185 69.0432 16.8655Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9758 25.572L91.1425 26.4477C91.0394 26.4735 90.9364 26.4735 90.8334 26.3962L88.4122 24.6705C87.7425 24.2068 86.8668 24.1296 86.1456 24.5159C85.4244 24.8765 84.9608 25.6235 84.935 26.4477L84.8835 29.4098C84.8835 29.5128 84.832 29.6158 84.7547 29.6674L82.3851 31.4446C81.7411 31.934 81.4063 32.7582 81.5351 33.5567C81.6639 34.3551 82.2305 35.0248 83.0032 35.3082L85.8108 36.2612C85.9138 36.2869 85.9911 36.3642 86.0168 36.4672L86.9698 39.3263C87.2274 40.099 87.8971 40.6656 88.7213 40.7944C89.5198 40.9232 90.344 40.5884 90.8334 39.9444L92.6106 37.5748C92.6621 37.4975 92.7652 37.446 92.8682 37.446L95.8303 37.3945C96.6545 37.3945 97.4015 36.9309 97.7621 36.1839C98.1227 35.4627 98.0711 34.587 97.6075 33.9173L95.9075 31.4961C95.856 31.4188 95.8303 31.2901 95.856 31.187L96.7318 28.3537C96.9636 27.581 96.7575 26.731 96.1909 26.1386C95.6242 25.5462 94.7742 25.3144 93.9758 25.572Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2679 28.327L46.1436 31.1603C46.1694 31.2633 46.1694 31.3664 46.0921 31.4694L44.3922 33.8906C43.9285 34.5602 43.8513 35.436 44.2376 36.1572C44.5982 36.8784 45.3452 37.342 46.1694 37.3678L49.1315 37.4193C49.2345 37.4193 49.3375 37.4708 49.389 37.5481L51.1663 39.9177C51.6557 40.5616 52.4799 40.8965 53.2784 40.7677C54.0768 40.6389 54.7465 40.0723 55.0298 39.2995L55.9829 36.492C56.0086 36.389 56.0859 36.3117 56.1889 36.286L58.9964 35.3329C59.7691 35.0754 60.3358 34.4057 60.4646 33.5815C60.5934 32.783 60.2585 31.9588 59.6146 31.4694L57.245 29.6921C57.1677 29.6406 57.1162 29.5376 57.1162 29.4346L57.0647 26.4467C57.0647 25.6225 56.601 24.8756 55.8541 24.515C55.1329 24.1544 54.2571 24.2059 53.5874 24.6695L51.1663 26.3952C51.089 26.4467 50.9602 26.4725 50.8572 26.4467L48.0239 25.571C47.2512 25.3392 46.4012 25.5452 45.8088 26.1119C45.2164 26.7043 45.0103 27.5543 45.2679 28.327Z",
    fill: "#FFC25D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5288",
    x: 49.709,
    y: 42.6631,
    width: 42.5254,
    height: 40.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5288"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5288",
    x: 27.2285,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5288"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1275_5288",
    x: 43.9902,
    y: 15.6807,
    width: 54.0078,
    height: 26.1668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5288"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5288",
    x1: 37.6824,
    y1: 11.4328,
    x2: 107.752,
    y2: 79.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes100);
export default __webpack_public_path__ + "static/media/Likes100.d15e9bcaa36539f71faafe4f5f1524c2.svg";
export { ForwardRef as ReactComponent };